const TakeMap = () => ({
  value: 0
});

export default TakeMap;
